import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./index.css";

export const NotFound = () => {
  const history = useHistory();
  const [seconds] = useState(5000);

  useEffect(() => {
    const setTimeoutId = setTimeout(() => {
      history.push("/");
    }, seconds);
    return () => {
      clearTimeout(setTimeoutId);
    };
  });

  return (
    <div className="notFound">
      <h1>404 - Pagina no encontrada...</h1>
      <h2>{`Redirigiendo a la pagina principal en ${seconds /
        1000} segundos.`}</h2>
    </div>
  );
};
